import React, { useEffect, useState } from "react";
import axios from "axios";

export default function CampaignRules(props) {
  const campaignname = props.match?.params?.name;

  const [budget, setBudget] = useState("");
  const [budgetType, setBudgetType] = useState("Daily Budget");
  const [abtesting, setABTesting] = useState("No");
  const [adsetbudget, setAdSetBudget] = useState("");
  const [gbmBudget, setGBMBudget] = useState("");

  const [hasBudget, setHasBudget] = useState(false);
  const [hasBudgetType, setHasBudgetType] = useState(false);
  const [hasABTesting, setHasABTesting] = useState(false);
  const [hasAdSetBudget, setHasAdSetBudget] = useState(false);
  const [hasGBMBudget, setHasGBMBudget] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loadError, setLoadError] = useState("");

  // Kampanya kuruldu durumu
  const [campaignStatus, setCampaignStatus] = useState("pending"); // "pending" | "setup"
  const [statusSaving, setStatusSaving] = useState(false);
  const [statusSuccess, setStatusSuccess] = useState(false);

  const toNumberOrNull = (v) => (v === "" ? null : Number(String(v).replace(",", ".")));
  const onlyDigits = (allowDecimal = false) =>
    allowDecimal ? /^\d*([.,]\d*)?$/ : /^\d*$/;
  const formatThousands = (val) => {
    if (val === "" || val == null) return "";
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setIsLoading(true);
        setLoadError("");
        const { data } = await axios.post(
          "https://act-api.vercel.app/findcampaignrule",
          { campaignname }
        );

        if (!mounted) return;

        setHasBudget(false);
        setHasBudgetType(false);
        setHasABTesting(false);
        setHasAdSetBudget(false);
        setHasGBMBudget(false);

        const rows = Array.isArray(data) ? data : [];

        // Status'u ilk kayıttan al
        if (rows.length > 0 && rows[0].status) {
          setCampaignStatus(rows[0].status);
        }

        rows.forEach((element) => {
          const desc = element?.ruleDescription;
          const val = element?.rule;

          if (desc === "Budget") {
            setHasBudget(true);
            setBudget(val !== undefined && val !== null ? String(val) : "");
          }
          if (desc === "Budget Type") {
            setHasBudgetType(true);
            setBudgetType(val ? String(val) : "Daily Budget");
          }
          if (desc === "A/B Testing") {
            setHasABTesting(true);
            setABTesting(val ? String(val) : "No");
          }
          if (desc === "Ad Set Budget") {
            setHasAdSetBudget(true);
            setAdSetBudget(val !== undefined && val !== null ? String(val) : "");
          }
          if (desc === "Target GBM budget" || desc === "Target GBM Budget") {
            setHasGBMBudget(true);
            setGBMBudget(val !== undefined && val !== null ? String(val) : "");
          }
        });
      } catch (e) {
        if (!mounted) return;
        setLoadError("Kurallar yüklenemedi. Lütfen tekrar deneyin.");
      } finally {
        mounted && setIsLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [campaignname]);

  async function submitAll() {
    setSuccess(false);
    setSaving(true);
    try {
      await axios.post("https://act-api.vercel.app/updateRule2", {
        campaignname,
        budget: toNumberOrNull(budget),
        budgetType,
        abtesting,
        adsetbudget: toNumberOrNull(adsetbudget),
        gbmBudget: toNumberOrNull(gbmBudget),
      });
      setSuccess(true);
    } finally {
      setSaving(false);
    }
  }

  async function markCampaignSetup() {
    setStatusSuccess(false);
    setStatusSaving(true);
    try {
      await axios.post("https://act-api.vercel.app/updateCampaignStatus", {
        campaignName: campaignname,
        status: "setup",
      });
      setCampaignStatus("setup");
      setStatusSuccess(true);
    } finally {
      setStatusSaving(false);
    }
  }

  const Section = ({ title, children }) => (
    <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <h3 className="text-sm font-semibold text-slate-700 mb-4">{title}</h3>
      {children}
    </section>
  );

  const Row = ({ label, children }) => (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 py-3">
      <div className="sm:w-48 shrink-0 text-sm text-slate-600">{label}</div>
      <div className="flex-1">{children}</div>
    </div>
  );

  const isSetup = campaignStatus === "setup";

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 text-slate-800">
      {/* Üst Başlık */}
      <div className="sticky top-0 z-10 bg-white/70 backdrop-blur supports-[backdrop-filter]:bg-white/50 border-b border-slate-200">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
          <div className="min-w-0">
            <h1 className="text-lg font-semibold truncate">{campaignname}</h1>
            <p className="text-xs text-slate-500 truncate">Campaign Rules</p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {/* Kampanya Kuruldu Butonu */}
            {isSetup ? (
              <span className="inline-flex items-center gap-1.5 rounded-lg bg-green-50 border border-green-200 px-3 py-2 text-sm font-semibold text-green-700">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
                Kampanya Kuruldu Mu ?
              </span>
            ) : (
              <button
                onClick={markCampaignSetup}
                disabled={statusSaving}
                className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-700 focus:ring-4 focus:ring-green-200 disabled:opacity-60 transition"
              >
                {statusSaving ? (
                  "Kaydediliyor…"
                ) : (
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                    Kampanya Kuruldu
                  </>
                )}
              </button>
            )}

            <button
              onClick={submitAll}
              disabled={saving}
              className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus:ring-4 focus:ring-blue-200 disabled:opacity-60 transition"
            >
              {saving ? "Saving…" : "Save Changes"}
            </button>
          </div>
        </div>
      </div>

      {/* İçerik */}
      <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8 space-y-6">
        {loadError && (
          <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
            {loadError}
          </div>
        )}
        {success && (
          <div className="rounded-xl border border-green-200 bg-green-50 p-4 text-sm text-green-700">
            You have successfully updated the information.
          </div>
        )}
        {statusSuccess && (
          <div className="rounded-xl border border-green-200 bg-green-50 p-4 text-sm text-green-700">
            Kampanya kuruldu olarak işaretlendi.
          </div>
        )}

        {/* Kampanya durumu banner */}
        {!isLoading && isSetup && (
          <div className="rounded-xl border border-green-200 bg-green-50 p-4 flex items-center gap-3">
            <div className="h-8 w-8 rounded-full bg-green-100 flex items-center justify-center shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-semibold text-green-800">Kampanya Kuruldu</p>
              <p className="text-xs text-green-600">Bu kampanya kuruldu olarak onaylandı.</p>
            </div>
          </div>
        )}

        {isLoading ? (
          <div className="space-y-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <div className="h-4 w-40 bg-slate-200 rounded animate-pulse mb-4" />
                <div className="h-10 w-full bg-slate-200 rounded animate-pulse" />
              </div>
            ))}
          </div>
        ) : (
          <>
            <Section title="Budget & Strategy">
              {hasBudget && (
                <Row label="Budget">
                  <input
                    type="text"
                    inputMode="numeric"
                    placeholder="Enter budget"
                    className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
                    value={formatThousands(budget)}
                    onChange={(e) => {
                      const raw = e.target.value.replace(/\./g, "");
                      if (raw === "" || onlyDigits(false).test(raw)) setBudget(raw);
                    }}
                  />
                </Row>
              )}

              {hasAdSetBudget && (
                <Row label="Ad Set Budget">
                  <input
                    type="text"
                    inputMode="numeric"
                    placeholder="Enter ad set budget"
                    className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
                    value={formatThousands(adsetbudget)}
                    onChange={(e) => {
                      const raw = e.target.value.replace(/\./g, "");
                      if (raw === "" || onlyDigits(false).test(raw)) setAdSetBudget(raw);
                    }}
                  />
                </Row>
              )}

              {hasBudgetType && (
                <Row label="Budget Type">
                  <select
                    className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
                    value={budgetType}
                    onChange={(e) => setBudgetType(e.target.value)}
                  >
                    <option>Daily Budget</option>
                    <option>Lifetime Budget</option>
                  </select>
                </Row>
              )}

              {hasABTesting && (
                <Row label="A/B Testing">
                  <div className="flex items-center gap-4">
                    {["Yes", "No"].map((val) => (
                      <label key={val} className="inline-flex items-center gap-2 text-sm">
                        <input
                          type="radio"
                          className="h-4 w-4 border-slate-300 text-blue-600 focus:ring-blue-500"
                          value={val}
                          checked={abtesting === val}
                          onChange={(e) => setABTesting(e.target.value)}
                        />
                        <span>{val}</span>
                      </label>
                    ))}
                  </div>
                </Row>
              )}

              {hasGBMBudget && (
                <Row label="Target GBM Budget">
                  <input
                    type="text"
                    inputMode="numeric"
                    placeholder="Enter target GBM budget"
                    className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-400"
                    value={formatThousands(gbmBudget)}
                    onChange={(e) => {
                      const raw = e.target.value.replace(/\./g, "");
                      if (raw === "" || onlyDigits(false).test(raw)) setGBMBudget(raw);
                    }}
                  />
                </Row>
              )}
            </Section>

            <div className="flex justify-end">
              <button
                onClick={submitAll}
                disabled={saving}
                className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus:ring-4 focus:ring-blue-200 disabled:opacity-60"
              >
                {saving ? "Saving…" : "Save Changes"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
